import { Input, notification } from "antd";
import SVG from "components/common/SVG";
import { ROLE } from "constants/phase";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useOutletContext } from "react-router-dom";

const BasicInfo = ({ id, orgWsData, getUploadPicture, editOrganization, editWorkspace, getEntityDetails }) => {
  const [profilePicture, setProfilePicture] = useState(orgWsData?.logo);
  const [agreementLink, setAgreementLink] = useState("");
  const [name, setName] = useState(orgWsData?.displayName);
  const { currentRole } = useOutletContext();

  const updateOrganizationDetails = async () => {
    if (id.startsWith("org")) {
      const payload = {
        logo: profilePicture || orgWsData?.logo,
        name: name || orgWsData?.displayName,
        organizationId: id,
      };
      const { value } = await editOrganization(payload);
      if (value?.status) {
        getEntityDetails();
        notification.success({ message: value?.message });
      } else {
        notification["error"]({ message: value?.message });
      }
    } else if (id.startsWith("ws")) {
      const payload = {
        logo: profilePicture || orgWsData?.logo,
        name: name || orgWsData?.displayName,
        workspaceId: id,
      };

      const { value } = await editWorkspace(payload);
      if (value?.status) {
        notification.success({ message: value?.message });
      }
    }
  };

  useEffect(() => {
    setName(orgWsData?.displayName);
    setProfilePicture(orgWsData?.logo);
  }, [orgWsData]);

  useEffect(() => {
    getEntityDetails();
  }, []);

  const onDrop = async (acceptedFiles) => {
    const files = acceptedFiles;
    const file = files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = async () => {
          const data = new FormData();
          data.append("file", file);
          data.append("filename", file.name);
          let type = file?.type.split("/")[0];
          let title = file.name;
          await uploadFileAndGetUrl(data, type, title);
        };
      };
      reader.readAsDataURL(file);
    } else {
      notification["warning"]({ message: "Please select valid file!" });
    }
  };

  const uploadFileAndGetUrl = async (data, type) => {
    if (type !== "image") {
      notification["warning"]({ message: "Wrong file uploaded!" });
    } else {
      const { value } = await getUploadPicture(data);
      if (value.status) {
        setProfilePicture(value.data);
      }
    }
  };

  return (
    <>
      <div className="right-container--op">
        <div className="title-block--op">
          <h4>Basic Information</h4>
        </div>
        <div className="border-block--op">
          <div className="items-block--op mb-5">
            {currentRole === ROLE.SUPER_ADMIN ? (
              <>
                <h6>
                  Name <span className="required">*</span>
                </h6>
                <Input
                  className="form-control"
                  value={name || orgWsData?.displayName}
                  onChange={(e) => setName(e.target.value)}
                />
              </>
            ) : (
              <>
                <h6>Name</h6>
                <h4>{name || orgWsData?.displayName}</h4>
              </>
            )}
          </div>
          <div className="items-block--op mb-5">
            <h6>Display icon</h6>

            <div className="style_formItem__tzSDC style_formProfilePictureItem__EliEn">
              {profilePicture || orgWsData?.logo ? (
                <div className="op--icon-block">
                  <img src={profilePicture || orgWsData?.logo} alt="profile-preview" />
                </div>
              ) : (
                <SVG iconName={"images/preview-profile-picture.svg"} />
              )}
              {currentRole === ROLE.SUPER_ADMIN && (
                <div className="style_profilePictureCta__-++QG">
                  <Dropzone accept="image/*" multiple={false} onDrop={onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div>Update picture</div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              )}
            </div>
          </div>
          {/* <div className="items-block--op mb-5">
            <h6>Agreement link</h6>
            {currentRole === ROLE.SUPER_ADMIN ? (
              <Input
                className="form-control"
                value={agreementLink || "https://www.hotstar.com/in/sports/agreement?date-2-01-24"}
                onChange={(e) => setAgreementLink(e.target.value)}
                              />
            ) : (
              <h6>
                <a href="#">https://www.hotstar.com/in/sports/agreement?date-2-01-24</a>
              </h6>
            )}
          </div> */}
          {currentRole === ROLE.SUPER_ADMIN && (
            <div className="items-block--op">
              <button
                class="btn btn-primary"
                onClick={() => updateOrganizationDetails()}
                disabled={!((profilePicture || orgWsData?.logo) && (name || orgWsData?.displayName))}
              >
                Update
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BasicInfo;
